// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "vue-assets/css/" + chunkId + "." + {"616":"541dc0e6","761":"a5c72e2b","1848":"541dc0e6","4376":"356ac4d9","7462":"541dc0e6","8163":"541dc0e6","8701":"10278ad0"}[chunkId] + ".css";
};